import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { GlobalState } from "../../store";
import { EventPackage, EventType } from "../types";

interface StateType {
  data: EventPackage[];
  selected: EventPackage | null;
}

const initialState: StateType = {
  data: [],
  selected: null,
};

export const packagesState = createSlice({
  name: "packages",
  initialState,

  reducers: {
    setPackages: (state: StateType, action: PayloadAction<EventPackage[]>) => {
      state.data = action.payload;
    },
    setPackageSelected: (
      state: StateType,
      action: PayloadAction<EventPackage | null>
    ) => {
      state.selected = action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.packages;
export const selectPackages = createSelector(selector, (s) => s.data);
export const selectPackageSelected = createSelector(
  selector,
  (s) => s.selected
);
